import SafeImage from "./SafeImage";

const ProjectCard = ({ project, animationDelay = "0ms" }) => {
  return (
    <div
      className="col-md-6 col-xl-4 wow fadeInLeft"
      data-wow-delay={animationDelay}
      data-wow-duration="1500ms"
    >
      <div className="blog-block-two mb-30">
        <div className="inner-box">
          <div className="image-box">
            <figure className="image">
              <SafeImage
                src={project.mainImagePath}
                alt={project.name}
                style={{ width: "100%", aspectRatio: "3 / 2", objectFit: "cover" }}
              />
              {project.projectYear && <span className="tag">{project.projectYear}</span>}
            </figure>
          </div>
          <div className="content-box">
            {project.clientName && (
              <ul className="info">
                <li>
                  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.10742 7.625C9.38086 7.625 11.2324 9.47656 11.2324 11.75C11.2324 12.1719 10.8809 12.5 10.4824 12.5H1.48242C1.06055 12.5 0.732422 12.1719 0.732422 11.75C0.732422 9.47656 2.56055 7.625 4.85742 7.625H7.10742ZM1.85742 11.375H10.084C9.89648 9.89844 8.63086 8.75 7.10742 8.75H4.85742C3.31055 8.75 2.04492 9.89844 1.85742 11.375ZM5.98242 6.5C4.31836 6.5 2.98242 5.16406 2.98242 3.5C2.98242 1.85938 4.31836 0.5 5.98242 0.5C7.62305 0.5 8.98242 1.85938 8.98242 3.5C8.98242 5.16406 7.62305 6.5 5.98242 6.5ZM5.98242 1.625C4.92773 1.625 4.10742 2.46875 4.10742 3.5C4.10742 4.55469 4.92773 5.375 5.98242 5.375C7.01367 5.375 7.85742 4.55469 7.85742 3.5C7.85742 2.46875 7.01367 1.625 5.98242 1.625Z"
                      fill="#1A4137" />
                  </svg>
                  {project.clientSlug ? (
                    <a href={`/clients/${project.clientSlug}`}>{project.clientName}</a>
                  ) : (
                    <span>{project.clientName}</span>
                  )}
                </li>
              </ul>
            )}
            <h4 className="title">
              <a href={`/our-projects/${project.slug}`}>{project.name}</a>
            </h4>
            {project.shortDescription && (
              <p className="text text-clamp-2">{project.shortDescription}</p>
            )}
            <a className="btn-one-rounded mt-30" href={`/our-projects/${project.slug}`}>
              View Project <i className="fa-solid fa-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
